import * as Api from '@ViewModels';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { reactQueryClient } from '../../web/ReactQueryProvider';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'note';

export const noteByIdQueryOptions = (userSession: Api.UserSessionContext, id: string | undefined | null) =>
	queryOptions<Api.INote>({
		enabled: !!id,
		queryFn: () => userSession.webServiceHelper.callAsync<Api.INote>(`note/${id}`, 'GET'),
		queryKey: [BASE_QUERY_KEY, id],
	});

/**
 * Fetches a single note by id (`GET note/{id}`). No impersonation — note reads are scoped
 * server-side. Disabled when `id` is empty so callers can pass an optional account note id
 * directly. Returns the full `Api.INote` (carrying `content`, `creator`, `lastModifiedDate`,
 * `preview`) for read-only display.
 */
export function useNoteByIdQuery(id: string | undefined | null) {
	const userSession = useUserSession();
	return useQuery(noteByIdQueryOptions(userSession, id));
}

export const invalidateNoteById = (id: string | undefined | null) => {
	if (!id) {
		return;
	}
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, id] });
};
